var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.433,
    height: 22,
    viewBox: "0 0 22.433 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 310",
    d: "M373.743 1696.209h-1.135a9.235 9.235 0 0 0-8.267-8.268v-.918a.907.907 0 1 0-1.815 0v.918a9.235 9.235 0 0 0-8.267 8.268h-1.135a.907.907 0 0 0 0 1.814h1.135a9.234 9.234 0 0 0 8.267 8.267v.919a.907.907 0 0 0 1.815 0v-.919a9.234 9.234 0 0 0 8.267-8.267h1.135a.907.907 0 0 0 0-1.814zm-10.31 8.379a7.472 7.472 0 1 1 7.472-7.472 7.481 7.481 0 0 1-7.472 7.473z",
    transform: "translate(-352.217 -1686.116)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 311",
    d: "M365.759 1695.173a4.2 4.2 0 1 0 4.2 4.2 4.2 4.2 0 0 0-4.2-4.2zm0 7.235a3.035 3.035 0 1 1 3.035-3.035 3.038 3.038 0 0 1-3.035 3.035z",
    transform: "translate(-354.542 -1688.373)",
    style: {
      fill: "#254089"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/target-icon.40457a20e3312fea017d9c97f2d502eb.svg";
export { ForwardRef as ReactComponent };